import { render, staticRenderFns } from "./ColorectalScreening.vue?vue&type=template&id=4364befa&scoped=true"
import script from "./ColorectalScreening.vue?vue&type=script&lang=js"
export * from "./ColorectalScreening.vue?vue&type=script&lang=js"
import style0 from "./ColorectalScreening.vue?vue&type=style&index=0&id=4364befa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4364befa",
  null
  
)

export default component.exports